import React from "react";
import { useQuickSightNetworking } from "@/hooks/useNetworkingReports";
import AWSReportsTemplate from "@/components/templates/AWSReportsTemplate";
import QuickSightAwsNetworkingDashboard from "@/components/organisms/NetworkingDashboard";

function NetworkingReports() {
  const { embedUrl, loading, error, refetch } = useQuickSightNetworking();

  return (
    <AWSReportsTemplate
      title="AWS Networking Dashboard"
      loading={loading}
      error={error}
      onRetry={refetch}
      hideFilters={true}
      hideDownload={true}
    >
      <QuickSightAwsNetworkingDashboard />
    </AWSReportsTemplate>
  );
}

export default NetworkingReports;
